export default __webpack_public_path__ + "media/images/icone-excel-018f9cff1a79dfaed197c61d099f6208.jpg";